// src/modules/Profile/services/ProfileUpdateService.ts
import { UpdateUserPayload } from '../models/Payloads';
import { ProfileApiAdapter } from '../adapters/ProfileApiAdapter';

export class ProfileUpdateService {
  constructor(private adapter: ProfileApiAdapter) {}

  async updateUser(payload: UpdateUserPayload): Promise<void> {
    return this.adapter.updateUser(payload); // ✅ sólo pasa el payload
  }

  async updateEmail(payload: {
    newEmail: string;
    password: string;
  }): Promise<void> {
    return this.adapter.updateEmail(payload);
  }
}
